// Lazy load node components for better performance
import { lazy } from 'react';

// Original AI Flow nodes - lazy loaded
const LLMNode = lazy(() => import('./LLMNode'));
const ImageGenNode = lazy(() => import('./ImageGenNode'));
const DataInputNode = lazy(() => import('./DataInputNode'));
const DataTransformNode = lazy(() => import('./DataTransformNode'));
const DataOutputNode = lazy(() => import('./DataOutputNode'));
const ConditionNode = lazy(() => import('./ConditionNode'));
const LoopNode = lazy(() => import('./LoopNode'));
const TriggerNode = lazy(() => import('./TriggerNode'));
const TextAnalysisNode = lazy(() => import('./TextAnalysisNode'));

// New Conversational AI blocks - lazy loaded
const MessageBlock = lazy(() => import('./MessageBlock'));
const ButtonBlock = lazy(() => import('./ButtonBlock'));
const PromptBlock = lazy(() => import('./PromptBlock'));
const SetVariableBlock = lazy(() => import('./SetVariableBlock'));
const SwitchBlock = lazy(() => import('./SwitchBlock'));
const IntentBlock = lazy(() => import('./IntentBlock'));
const ApiCallBlock = lazy(() => import('./ApiCallBlock'));
const IntegrationBlock = lazy(() => import('./IntegrationBlock'));
const FunctionBlock = lazy(() => import('./FunctionBlock'));
const EndBlock = lazy(() => import('./EndBlock'));
const CodeBlock = lazy(() => import('./CodeBlock'));

// 7h3 Agency — Composio integration node
const ComposioNode = lazy(() => import('./ComposioNode'));

// Previously unregistered — full processor support added server-side in
// worker/src/nodeProcessors.js; this wires them into the canvas.
const AdvancedButtonBlock = lazy(() => import('./AdvancedButtonBlock'));
const AIModelBlock = lazy(() => import('./AIModelBlock'));
const APIStepBlock = lazy(() => import('./APIStepBlock'));
const CaptureBlock = lazy(() => import('./CaptureBlock'));
const ChoiceFlowBlock = lazy(() => import('./ChoiceFlowBlock'));
const ConditionFlowBlock = lazy(() => import('./ConditionFlowBlock'));
const DynamicImageBlock = lazy(() => import('./DynamicImageBlock'));
const EndStepBlock = lazy(() => import('./EndStepBlock'));
const EnhancedMessageBlock = lazy(() => import('./EnhancedMessageBlock'));
const SetFlowBlock = lazy(() => import('./SetFlowBlock'));
const SmartAIModelBlock = lazy(() => import('./SmartAIModelBlock'));

export const nodeTypes = {
  // Original nodes
  llm: LLMNode,
  imageGen: ImageGenNode,
  textAnalysis: TextAnalysisNode,
  dataInput: DataInputNode,
  dataTransform: DataTransformNode,
  dataOutput: DataOutputNode,
  condition: ConditionNode,
  loop: LoopNode,
  trigger: TriggerNode,

  // New conversational AI blocks
  message: MessageBlock,
  button: ButtonBlock,
  prompt: PromptBlock,
  setVariable: SetVariableBlock,
  switch: SwitchBlock,
  intent: IntentBlock,
  apiCall: ApiCallBlock,
  integration: IntegrationBlock,
  function: FunctionBlock,
  end: EndBlock,
  code: CodeBlock,

  // 7h3 Agency — Composio tools (1000+ external integrations)
  composio: ComposioNode,

  // Previously unregistered node types — now live
  advancedButton: AdvancedButtonBlock,
  aiModel: AIModelBlock,
  apiStep: APIStepBlock,
  capture: CaptureBlock,
  choiceFlow: ChoiceFlowBlock,
  conditionFlow: ConditionFlowBlock,
  dynamicImage: DynamicImageBlock,
  endStep: EndStepBlock,
  enhancedMessage: EnhancedMessageBlock,
  setFlow: SetFlowBlock,
  smartAIModel: SmartAIModelBlock,
};
